module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/69.dc62a9c7.png";